import { McIcon, McTooltip } from '@maersk-global/mds-react-wrapper';
import React from 'react';
import { Holiday } from '../../common/service/holidays/types';
import { Event } from '../../common/service/events/types';

const AffectedRenderer = ({ entity, type }: { entity: Holiday | Event; type: 'gate' | 'vesselOps' }) => {
  if (entity[type] === 'NO') {
    return <span>Not affected</span>;
  }
  return (
    <McTooltip appearance="neutral-default" width={400} fit="small">
      <div slot="trigger">
        <div className="Holidays__affected">
          Affected <McIcon size="16" icon="info-circle" />
        </div>
      </div>
      <div>
        <div>{type === 'gate' ? 'Gate affected' : 'Vessel Ops stopped'}:</div>
        {entity[type] === 'YES' ? (
          <span>
            All day{' '}
            {'date' in entity
              ? formatDate(entity.date)
              : `${formatDate(entity.fromDateTime).substring(0, 10)} - ${formatDate(entity.toDateTime).substring(0, 10)}`}
          </span>
        ) : null}
        {(type === 'gate' ? entity.gateTimeSlots : entity.vesselOpsTimeSlots)?.map((slot, index) => (
          <div key={index}>
            &bull;&nbsp;{formatDate('date' in entity ? slot.from : slot.from.substring(11, 16))} -{' '}
            {formatDate('date' in entity ? slot.to : slot.to.substring(11, 16))}
          </div>
        ))}
      </div>
    </McTooltip>
  );
};
export default AffectedRenderer;

const formatDate = (value: string) => value.replace('T', ' ').replaceAll('-', '/').substring(0, 16);
